// extracted by mini-css-extract-plugin
export default {"mlhLogo":"Navigator_mlhLogo__Dp03p","hhlogo":"Navigator_hhlogo__5sJ2T","brand":"Navigator_brand__ODK1f"};